<template>
  <div class="content">
     <el-form :model="queryParams" ref="queryForm"  :inline="true">
      <el-form-item prop="productName">
        <el-input
          v-model="queryParams.productName"
          placeholder="请输入套餐名称"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item prop="productType">
        <el-select v-model="queryParams.productType" filterable clearable placeholder="请输入套餐类型">
          <el-option v-for="item in productTypes" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="openSelectProdcut"
          v-hasPermi="['agent:customProduct:save']"
        >自定义套餐价格</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          icon="el-icon-close"
          @click="handleClose"
        >关闭</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" border :data="productList" >
      <el-table-column type="index" align="center" />
      <el-table-column label="套餐ID" prop="id" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="代理商名称" prop="companyName" min-width="160" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="scope">
            <span>[{{scope.row.username}}]{{scope.row.companyName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="套餐名称" prop="productName" min-width="160" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="套餐类型" prop="productType" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="运营商价格" align="center" min-width="500px">
          <template slot-scope="scope">
            <el-descriptions :column="3" :colon="false"  >
             <template v-for="(item,index) in scope.row.products" >
                <el-descriptions-item :key="index">{{item.operatorName}}</el-descriptions-item>
                <el-descriptions-item label="运营商价格" :key="index">
                  <el-tag size="small">{{item.price}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="加价价格" :key="index">
                  <el-tag size="small">{{!item.extraPrice? 0 : item.extraPrice}}</el-tag>
                </el-descriptions-item>
             </template>
          </el-descriptions>
          </template>
      </el-table-column>
      <el-table-column label="市场价格" prop="showPrice" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="套餐总量/M" prop="flowCount" align="center" min-width="120" :show-overflow-tooltip="true" />
      <el-table-column label="套餐有效期/天" prop="validityTime" align="center" min-width="120" :show-overflow-tooltip="true" />
      <el-table-column label="种类" prop="customProduct" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="scope">
            <el-tag v-if="scope.row.customProduct == '1'">自定义套餐</el-tag>
            <el-tag v-if="scope.row.customProduct == '2'" type="success">套餐组</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="来源" prop="source" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="scope">
            <el-tag v-if="scope.row.source == '1'">本级</el-tag>
            <el-tag v-if="scope.row.source == '2'" type="success">上级</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="130" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-circle-close"
            @click="customProductCancel(scope.row)"
            v-hasPermi="['agent:customProduct:cancel']"
            v-if="scope.row.customProduct == '1' && scope.row.source=='1'"
          >删除自定义套餐</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />
    <select-product ref="select" :userId="queryParams.userId" @ok="handleQuery" />
  </div>
</template>

<script>
import {agentCustomProduct,productType, customProductCancel } from "@/api/api";
import selectProduct from "./selectProduct";

export default {
  name: "AgentProduct",
  components: { selectProduct },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中用户组
      userIds: [],
      // 非多个禁用
      multiple: true,
      // 总条数
      total: 0,
      // 代理商套餐表格数据
      productList: [],
      pageNum: 1,
      pageSize: 10,
      // 查询参数
      queryParams: {
        userId: undefined,
        productName: undefined,
        productType: undefined
      },
      productTypes:[]
    };
  },
  created() {
    const userId = this.$route.params && this.$route.params.userId;
    if (userId) {
      sessionStorage.setItem('agentProduct', userId);
      this.queryParams.userId = userId;
      this.getList();
    }else{
      this.queryParams.userId = sessionStorage.getItem('agentProduct');
      this.getList();
    }
    this.productTypeList();
  },
  watch: {
    // 监听路由中userId参数变化
    '$route.params.userId'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        sessionStorage.setItem('agentProduct', newVal);
        this.queryParams.userId = newVal;
        this.resetQuery(); // 重置搜索条件
      }
    }
  },
  methods: {
    /** 查询代理商套餐列表 */
    getList() {
      this.loading = true;
      this.productList = [];
      let params = {
        model: {
          ... this.queryParams
        },
        page: this.pageNum,
        pageSize: this.pageSize
      }
      agentCustomProduct(params).then(res => {
          this.productList = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
        }
      );
    },
    
    //套餐类型列表
    productTypeList(){
      productType().then(res =>{
        this.productTypes = res.data.data;
      })   
    },
    // 返回按钮
    handleClose() {
      const obj = { path: "/partners/agent" };
      this.$tab.closeOpenPage(obj);
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    openSelectProdcut() {
      this.$refs.select.show();
    },
    /** 取消自定义套餐价格 */
    customProductCancel(row) {
      let userId = this.queryParams.userId
      this.$modal.confirm('确认要删除"' + row.productName + '"设置的自定义价格？').then(function() {
        return customProductCancel({ userId: userId, productId: row.id });
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("取消授权成功");
      }).catch(() => {});
    }
  }
};
</script>